<template>
  <nav-menu
    name="Invitations / RSVPs"
    title="Send any card as an invitation"
    subtitle="Customize and track RSVPs automatically"
    action="View invitations"
    :icon="mdiCards"
    :to="{ name: 'catalog', query: { q: 'Invitation', type: 'INVITATION' } }"
    v-bind="$attrs" v-on="$listeners"
  >
    <div class="pa-3 d-flex flex-column-reverse d-sm-block">
      <div class="mt-3 mt-sm-0 float-sm-right" v-bind:style="{ width: $vuetify.breakpoint.xsOnly ? '100%' : '320px' }">
        <v-card outlined>
          <v-responsive :aspect-ratio="16 / 9">
            <video width="100%" playsinline="" autoplay="autoplay" muted="muted" loop="loop" src="https://cdn.ellacard.com/nav/invitations_320x180.mp4" class="d-block" />
          </v-responsive>
        </v-card>
        <div class="mt-2 caption">Build RSVP forms with custom questions and automatically collect responses from recipients</div>
      </div>

      <div>
        <div class="caption">Invitations for any occasion</div>
        <div
          v-for="[ q, icon ] in [
            [ 'Party', mdiBalloon ],
            [ 'Holiday', mdiPineTree ],
            [ 'Baby Shower', mdiBabyCarriage ],
            [ 'Retirement', mdiBriefcaseCheck ],
            [ 'Save the Date', mdiCalendarHeart ]
          ]"
          class="mx-n2"
        >
          <v-btn text color="primary" :to="{ name: 'catalog', query: { q: [ 'Invitation', q ], type: 'INVITATION' } }">
            <v-icon small class="mr-1" v-html="icon" />{{q}}
          </v-btn>
        </div>
        <div class="mx-n2">
          <v-btn text color="primary" :to="{ name: 'catalog', query: { q: [ 'Invitation', 'Template', 'blank' ], type: 'INVITATION' } }">
            <v-icon small class="mr-1" v-html="mdiPencilBoxOutline" />Design your own…
          </v-btn>
        </div>
      </div>
    </div>
  </nav-menu>
</template>

<script>
import NavMenu from '@/components/NavMenu.vue';
import { mdiCards, mdiBalloon, mdiPineTree, mdiBabyCarriage, mdiBriefcaseCheck, mdiCalendarHeart, mdiPencilBoxOutline } from '@mdi/js';

export default {
  name: 'nav-menu-group-greeting-cards',

  components: {
    NavMenu
  },

  created() {
    Object.assign(this, { mdiCards, mdiBalloon, mdiPineTree, mdiBabyCarriage, mdiBriefcaseCheck, mdiCalendarHeart, mdiPencilBoxOutline });
  }
}
</script>
